import React from 'react';
import { Typography, Box } from '@mui/material';
import CommonModal from 'pages/ShareYourLight/components/CommonModal';
import ShieldIcon from '@mui/icons-material/ShieldOutlined';

interface CommunityRulesModalProps {
  open: boolean;
  onClose: () => void;
}

function CommunityRulesModal({ open, onClose }: CommunityRulesModalProps) {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      paperSx={{ maxWidth: 700, width: '100%' }}
      title={(
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 6 }}>
          <ShieldIcon sx={{ color: '#FED892', fontSize: 24, fontWeight: 700, mr: 1 }} />
          <Typography variant='h4' sx={{ color: '#FED892', fontWeight: 500 }} fontSize={20}>
            Rules of engagement
          </Typography>
        </Box>
)}
    >
      <Box sx={{ textAlign: 'center' }}>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 4,
            mb: 3,
          }}
        >
          <Box sx={{ flex: 1, textAlign: 'left' }}>
            <Typography
              variant='h6'
              sx={{ color: '#DADADA', fontWeight: 700, mb: 1, whiteSpace: 'nowrap' }}
              fontSize={16}
            >
              Want to share
            </Typography>
            <ul style={{ color: '#DADADA', fontSize: 14, margin: 0, paddingLeft: 24, listStyle: 'none', paddingInlineStart: 0 }}>
              {[
                'Inspirational quotes or personal mantras',
                'Stories of resilience and overcoming challenges',
                'Words of comfort for those who need support',
                'Gratitude and appreciation messages',
              ].map((item) => (
                <li key={item} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 4 }}>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      background: '#FED892',
                      marginRight: 8,
                      marginTop: 8,
                      flexShrink: 0,
                    }}
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Box>
          <Box sx={{ flex: 1, textAlign: 'left' }}>
            <Typography variant='h6' sx={{ color: '#DADADA', fontWeight: 700, mb: 1 }} fontSize={16} whiteSpace='nowrap'>
              Community guidelines
            </Typography>
            <ul style={{ color: '#DADADA', fontSize: 14, margin: 0, paddingLeft: 24, listStyle: 'none', paddingInlineStart: 0 }}>
              {[
                'No hate speech, discrimination, harassment, or harmful content',
                'Keep content safe and appropriate for all ages and backgrounds',
                'No personal information, contact details, or identifiers',
                'No explicit descriptions of self-harm methods or promotion of harmful behaviors',
              ].map((item) => (
                <li key={item} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 4 }}>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      background: '#FED892',
                      marginRight: 8,
                      marginTop: 8,
                      flexShrink: 0,
                    }}
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Box>
        </Box>
        <Typography sx={{ color: '#9C9C9C', fontSize: 12, mt: 2, textAlign: 'left' }}>
          <b>Remember:</b>
          {' '}
          All submissions are reviewed before posting to help protect the safety and privacy of
          participants. This forum is a safe, anonymous space for peer support and encouragement.
          If you are experiencing a mental health crisis, please reach out to professional services
          immediately.
        </Typography>
      </Box>
    </CommonModal>
  );
}

export default CommunityRulesModal;
